export default {
    name: 'qesg-dash-card-props',
    props: {
        icon: {
            type: String,
            required: false,
            default: (iconProps) => typeof iconProps === 'undefined' ? '' : iconProps
        },
        iconFontScale: {
            type: Number,
            required: false,
            default: 0
        },
        iconVariant: {
            type: String,
            required: false,
            default: 'dark'
        }
    }
}